import { ComponentArea, FindNativeFeature, GetIframeAndNativeEditors, GetPlainNoteFeature, GetSuperNoteFeature, NoteType, } from '@standardnotes/features';
import { UIFeature } from '@standardnotes/models';
export class EditorForNoteUseCase {
    constructor(items) {
        this.items = items;
    }
    execute(note) {
        if (note.noteType === NoteType.Plain) {
            return new UIFeature(GetPlainNoteFeature());
        }
        if (note.noteType === NoteType.Super) {
            return new UIFeature(GetSuperNoteFeature());
        }
        if (note.editorIdentifier) {
            const result = this.componentOrNativeFeatureForIdentifier(note.editorIdentifier);
            if (result) {
                return result;
            }
        }
        if (note.noteType && note.noteType !== NoteType.Unknown) {
            const result = this.nativeEditorForNoteType(note.noteType);
            if (result) {
                return new UIFeature(result);
            }
        }
        const legacyResult = this.legacyGetEditorForNote(note);
        if (legacyResult) {
            return new UIFeature(legacyResult);
        }
        return new UIFeature(GetPlainNoteFeature());
    }
    componentOrNativeFeatureForIdentifier(identifier) {
        const nativeFeature = FindNativeFeature(identifier);
        if (nativeFeature) {
            return new UIFeature(nativeFeature);
        }
        const component = this.items.getDisplayableComponents().find((component) => {
            return component.identifier === identifier;
        });
        if (component) {
            return new UIFeature(component);
        }
        return undefined;
    }
    nativeEditorForNoteType(noteType) {
        const nativeEditors = GetIframeAndNativeEditors();
        return nativeEditors.find((editor) => editor.note_type === noteType);
    }
    /** Uses legacy approach of note/editor association. New method uses note.editorIdentifier and note.noteType directly. */
    legacyGetEditorForNote(note) {
        const editors = this.thirdPartyComponentsForArea(ComponentArea.Editor);
        for (const editor of editors) {
            if (editor.isExplicitlyEnabledForItem(note.uuid)) {
                return editor;
            }
        }
        const defaultEditor = this.legacyGetDefaultEditor();
        if (defaultEditor && !defaultEditor.isExplicitlyDisabledForItem(note.uuid)) {
            return defaultEditor;
        }
        else {
            return undefined;
        }
    }
    legacyGetDefaultEditor() {
        const editors = this.thirdPartyComponentsForArea(ComponentArea.Editor);
        return editors.filter((e) => e.legacyIsDefaultEditor())[0];
    }
    thirdPartyComponentsForArea(area) {
        return this.items.getDisplayableComponents().filter((component) => {
            return component.area === area;
        });
    }
}
